import {
  addQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPost,
  AddQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPostData,
  AddQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPostResponse,
  HTTPValidationError,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import studyQueryKeys from './queryKeyFactory'

export function useAddQueryMessage(): UseMutationResult<
  AddQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPostResponse,
  AxiosError<HTTPValidationError>,
  AddQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPostData
> {
  return useMutation<
    AddQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPostResponse,
    AxiosError<HTTPValidationError>,
    AddQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPostData
  >({
    mutationFn: async (query) => {
      const response = await addQueryMessageStudiesStudyIdQueriesStudyQueryIdMessagesPost({
        path: query.path,
        body: query.body,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: (_data, query) => {
      queryClient.invalidateQueries({ queryKey: studyQueryKeys.detail(query.path.study_id, query.path.study_query_id) })
    },
  })
}
